import { useState } from "react";
import axios from "axios";

export const useAxios = () => {
    const [response, setResponse] = useState(undefined);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [notAuthorized, setNotAuthorized] = useState(false);

    const fetchData = async axiosParams => {
        setLoading(true);
        setError(null);
        setResponse(undefined);

        try {
            const result = await axios.request(axiosParams);

            setResponse(result.data);
            return { data: result.data, error: null };
        } catch (err) {
            if (err.response?.status === 401) setNotAuthorized(true);

            const errorMessage = err.response?.data || "Ocorreu um erro inesperado";

            setError(errorMessage);
            return { data: null, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { response, error, loading, notAuthorized, fetchData };
};
